import { bootstrapApplication } from '@angular/platform-browser'
import { MenuStore } from '@corporate-tailwind/store'
import { App } from './app/app'
import { appConfig } from './app/app.config'
import { routes } from './app/app.routes'

bootstrapApplication(App, appConfig)
    .then(async appRef => {
        appRef.injector.get(MenuStore).initRoute(routes)
    })
    .catch(err => console.error(err))
